


















import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import LoadingSpinner from '@/components/LoadingSpinner.vue'

@Component({components: {LoadingSpinner}})
export default class FusionChart extends Vue {
  @Prop() private chartConfig!: object
  @Prop() private chartData!: object
  @Prop() private chartClickCallback!: () => any
  @Prop() private dataplotClickCallback!: (label: string, value: string, data?: any) => any
  @Prop() private errorMessage?: string
  public isLoading = true

  @Watch('chartData', {immediate: true, deep: true})
  private onChartDataChange(newVal: any) {
    if (process.env.NODE_ENV === "test") {
      this.isLoading = true
    } else {
      this.isLoading = !(newVal && newVal.chart)
    }
  }

  public chartEvents(t: any) {
    const that = this
    return {
      chartClick(evt: any) {
        evt.stopPropagation()
        if (typeof that.chartClickCallback != 'undefined') {
          that.chartClickCallback()
        }
      },
      dataplotClick(evt: any) {
        evt.stopPropagation()
        // console.debug('evt.data:', evt.data)
        that.dataplotClickCallback(evt.data.categoryLabel, evt.data.dataValue, evt.data)
      },
    }
  }
}
